import Preact from 'preact'
import { INames } from '../../../types'
import * as styles from './index.css'

const { h } = Preact

const flagsSprite = require(`../../../assets/flags-sprite.jpg`)
const flagsSprite2x = require(`../../../assets/flags-sprite@2x.jpg`)

interface IProps {
  class?: string
  names: INames
}

const FLAG_NAMES = [
  'ARG',
  'AUS',
  'BEL',
  'BRA',
  'COL',
  'COS',
  'DAN',
  'EGY',
  'ENG',
  'FRA',
  'IRA',
  'ISL',
  'JAP',
  'KOR',
  'KRO',
  'MAR',
  'MEX',
  'NIG',
  'PAN',
  'PER',
  'POL',
  'POR',
  'RUS',
  'SAU',
  'SEN',
  'SER',
  'SPA',
  'SVE',
  'SVEI',
  'TUN',
  'TYS',
  'URU'
]

const Flag = (props: IProps) => {
  const { names } = props
  const className = `${styles.flag}${props.class ? ` ${props.class}` : ''}`
  const flagIndex = FLAG_NAMES.indexOf(names.short)

  if (flagIndex === -1) {
    return <div class={className} />
  }

  return (
    <div class={className}>
      <img
        src={flagsSprite}
        srcset={`${flagsSprite} 1x, ${flagsSprite2x} 2x`}
        style={{ transform: `translateX(${flagIndex / 32 * -100}%)` }}
      />
    </div>
  )
}

export { Flag }
